<template>
  <div>
    <transition name="fade">
      <v-progress-linear :value="progress" v-if="!ready"></v-progress-linear>
    </transition>
    <v-app-bar
      color="teal lighten-3"
      dark
      dense
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()">
        <v-icon>
          mdi-reload
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      color="teal lighten-2"
      dark
      absolute
      temporary
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Dashboard
          </v-list-item-title>
          <v-list-item-subtitle>
            <div class="d-flex align-center">
              <v-icon>
                mdi-account-group
              </v-icon>
              小組列表
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>
        <v-list-item
          link
          v-for="(item, i) in list" :key="i"
          @click="teamData = item; drawer = false"
        >
          <v-divider></v-divider>
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              第 {{item.team}} 組
            </v-list-item-title>
          </v-list-item-content>
          <v-divider></v-divider>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-container>
      <v-row v-if="teamData" class="mt-n4">
        <v-col cols="12">
          <v-chip class="justify-center" style="min-width:100px;" color="teal lighten-3" dark>
            第 {{teamData.team}} 組
          </v-chip>
        </v-col>
        <v-col
          lg="4"
          md="6"
          sm="6"
          cols="12"
          v-for="(log, j) in teamData.datas.status.logs"
          :key="j"
        >
          <div class="mb-4">
            <div>
              <v-chip>
                開始：{{log.startTimeStr}}
              </v-chip>
            </div>
            <div class="mt-2 d-flex">
              <v-chip small>
                花費{{log.spendMin}}分{{log.spendSec}}秒
              </v-chip>
            </div>
            <div class="mt-2">
              <v-chip>
                結束：{{log.endTimeStr}}
              </v-chip>
            </div>
            <div class="d-flex align-center mt-2">
              對象：
              <v-chip>
                {{log.target}}
              </v-chip>
            </div>
            <template>
              <div class="mt-2" v-if="log.match">
                <v-btn
                  v-for="(r, rn) in log.match"
                  :key="j + '-' + rn"
                  :color="r ? 'success' : 'error'"
                  class="mr-2"
                >
                  規則{{rn + 1}}
                </v-btn>
              </div>
              <div class="mt-2" v-else>
                <v-btn disabled>
                  沒有進行至該輪
                </v-btn>
              </div>
            </template>
            <div class="mt-2">
              <v-btn color="primary" @click="dialog.list = log.messages; dialog.show = true">
                詳細對話紀錄
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="dialog.show"
      width="500"
    >
      <v-card v-if="dialog.show">
        <v-card-title
          class="headline teal lighten-3"
          primary-title
        >
          對話紀錄
        </v-card-title>

        <v-card-text class="pt-4">
          <div v-for="(record, i) in dialog.list" :key="i">
            <div class="d-flex">
              <v-spacer v-if="record.sender.includes('team')"></v-spacer>
              <v-chip :class="nameChipClasses(record.sender)" small>
                {{record.sender}}:
              </v-chip>
            </div>
            <div class="d-flex">
              <v-spacer v-if="record.sender.includes('team')"></v-spacer>
              <span>
                {{record.content}}
              </span>
            </div>
            <v-divider v-if="dialog.list.length - 1 !== i" class="mt-2 mb-2"></v-divider>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.show = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from '@/lib/axios'
export default {
  data(){
    return {
      drawer: false,
      dialog: {
        show: false,
        list: []
      },
      ready: false,
      progress: 0,
      teamData: null,
      /**
       * team list
       */
      list: []
    }
  },
  mounted(){
    this.refreshList()
    // axios.get('http://localhost:7789/andy-self-test/us-central1/store/game/list', {
  },
  methods: {
    refreshList(){
      this.ready = false
      this.progress = 0
      this.teamData = null
      this.list = []
      let timer = setInterval(()=>{
        this.progress += 3
        if(this.progress >= 80){
          clearInterval(timer)
        }
      }, 200)
      return axios.get('https://us-central1-andy-self-test.cloudfunctions.net/store/game/list', {
        headers: {
          authorization: `Basic rRQ62nVrXA2JZRq2`
        }
      })
        .then((res)=>{
          let list = res.data.list.filter((item)=>{
            return typeof item.id === 'string'
          })
          // 每個 item 為一個隊伍的資料
          for(let item of list){
            // match team number
            let match = item.id.match(/team-(\d+)/)
            item.team = parseInt(match[1])
            if(Number.isNaN(item.team)){
              item.team = null
            }
            // 每個 log 為隊伍完成"整輪對話"的紀錄
            let logs = _.get(item, 'datas.status.logs', [])
            for(let log of logs){
              log.endTime = new Date(log.endTime)
              log.endTimeStr = log.endTime.toLocaleString()
              log.startTime = new Date(log.startTime)
              log.startTimeStr = log.startTime.toLocaleString()
              let ms = log.endTime - log.startTime
              log.spendMin = Math.floor(ms / 60000)
              log.spendSec = Math.floor(ms / 1000) % 60
            }
          }
          if(list.length > 0){
            this.teamData = list[0]
          }
          this.list = list
          this.progress = 100
          setTimeout(()=>{
            this.ready = true
          }, 500)
        })
        .catch((e)=>{
          console.error(e)
        })
    },
    nameChipClasses(sender){
      if(sender && sender.match(/^team-/)){
        return ['teal', 'lighten-4']
      }else{
        return []
      }
    }
  }
}
</script>

<style>
  .border{
    border: 1px solid black;
  }
</style>
